module.exports = __webpack_public_path__ + "static/media/5.4ef7c7ef.jpg";